<template>
  <div>
    <!--    TODO -->
    <WrapperPreviewCategory customClass="section-preview_lk">
      <GridTable
        :data-rows="showingServerData"
        :headers="headers.massive"
        :headers-for-rows="headersForRows"
        :loading-data="loadingData"
        :num-cols="headers.countCells"
        :max-table-height="maxTableHeight"
        ref="npg-table"
        :key="'form-5-05'"
      >
        <!--  v-if="!changingHeaders"  :key='' когда меняется хедер проверить    -->
        <template #header-npg0="{item}">
          <v-btn @click="loadFullInfo" class="white__v-btn">{{ !full ? 'Показать все' : "Скрыть пустые" }} строки
          </v-btn>
          {{ item.text }}
        </template>
        <template v-for="item in headersForRows" v-slot:[calcHeaderName(item.dataField)]>
          <div :key="item.dataField" :class="item.headerClass" style="max-height: 22px;min-width: 100%">
            <template v-if="item.text === '1'">
              <div style="min-width: 60px">1</div>
              <div class="text-center" style="width: 100%">2</div>
            </template>
            <template v-else>
              <div class="d-flex flex-row align-center" style="max-height: 22px;">
                {{ item.text }}
                <v-btn v-if="item.text !== '7'" small icon :outlined="false" @click="openTooltip(item.dataField)">
                  <v-icon
                    :size="14"
                    x-small
                    class="grey-light-color__important "
                  >
                    mdi-information
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </div>
        </template>
        <template #npg="{row, cell}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <v-btn :loading="savingData" @click="openDialog($event, null, cell, row)" icon>
              <v-icon size="24" color="primary">mdi-file-edit-outline</v-icon>
            </v-btn>
            <div style="">
              {{ row.spec ? row.spec.code : row.kcpUgs.code }}
            </div>
            <div class="ml-3">
              {{ row.spec ? row.spec.name : row.kcpUgs.name }}
            </div>
          </template>
        </template>
        <template v-for="item in headersForRowsWithEditableCells" v-slot:[item.dataField]="{row,cell}">
          <fives-table-cell
            :key="item.dataField"
            v-bind="item.props(row,cell, loadingMenu)"
            :disabled="organizationBlocked"
            @open-dialog="openDialog($event, item.dataField, cell, row)"
          />
        </template>
      </GridTable>
      <div class="mt-2" style="color: #89A0B0; font-size: 12px;">
        Примечание: При наличии профессионально-общественной аккредитации по УГСН в целом информация дублируется в
        строках по специальностям (направлениям подготовки), входящим в УГСН. При наличии профессионально-общественной
        аккредитации по образовательным программам, сведения указываются по тем специальностям (направлениям
        подготовки), к которым относятся данные образовательные программы
      </div>
      <div class="mt-3 d-flex flex-row justify-center align-center">
        <v-autocomplete
          class="pagination-table"
          v-model="userPages"
          :items="pagesPaginate"
          solo
          dense
          filled
          height="25"
          rounded
          style="max-width: 150px"
          @change="changePage($event)"
        ></v-autocomplete>
        <v-pagination
          v-model="page"
          :length="pagesVuetify"
          :total-visible="7"
          @input="changePage($event)"
        >
        </v-pagination>
      </div>
    </WrapperPreviewCategory>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeals-arr="appealsArr"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
    <universal-dialog-v1
      ref="dialog"
      :data-for-dialog="dataForDialog"
      :headers-for-dialog="headersForDialog"
      @fetch-new-data="fetchDialogData($event)"
      :loading="savingData"
      :additional-data="additionalData"
      @closing-dialog="clearDataForDialog()"
    >
      <template #title>
        <h2>{{ mainHeaderTitle ? mainHeaderTitle : 'Добавить' }}</h2>
      </template>
      <template #actions="{close, sendData, loading, validSolo, isOneStage}">
        <div class="d-flex flex-row align-center justify-center" style="width: 100%">
          <v-btn
            class='white__v-btn'
            @click="close()"
            width="120px"
          >
            Отменить
          </v-btn>
          <v-btn
            v-if="isOneStage"
            class='blue__v-btn  ml-2'
            @click="sendData()"
            :loading="loading"
            :disabled="!validSolo || disabled"
            width="120px"
          >
            Отправить
          </v-btn>
        </div>
      </template>
    </universal-dialog-v1>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import form505 from "./configs/form5-05";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import appealDialog from "@/components/Dialogs/appealDialog";
import {setAppealDialog} from "@/mixins/forms5/appealDialog";
import UniversalDialogV1 from "@/components/Dialogs/universalDialog(v1.2)";
import {tablePagination} from "@/mixins/tablePagination";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {fiveFormsMixin} from "@/mixins/formUsl";
import FivesTableCell from "@/components/fields/fivesTableCell";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "form5",
  mixins: [headerTooltipFunctions, setAppealDialog, tablePagination, fiveFormsMixin],
  components: {FivesTableCell, UniversalDialogV1, WrapperPreviewCategory, GridTable, tooltipForms5Dialog, appealDialog},
  props: {
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      serverData: [],
      loadingData: false,
      changingHeaders: false,
      headers: form505,
      full: false,
      savingData: false,
      dataForDialog: null,
      additionalData: null,
      mainHeaderTitle: '',
      headersForDialog: [
        {
          "text": "серия и номер бланка свидетельства",
          "dataField": "gpsnm23K22",
          "typeVar": "string",
          "rules": 'customRules',
          "customsRulesArray": [
            // v => v != null || 'Значение должно быть выбрано',
            // v => v != null && v.length <=15 || 'Значение должно быть больше 15 символов',
          ],
          "order": 0,
        },
        {
          "text": "серия и номер бланка приложения",
          "dataField": "gpsnp23K22",
          "typeVar": "string",
          "rules": 'customRules',
          "customsRulesArray": [
            // v => v != null || 'Значение должно быть выбрано',
            // v => v != null && v.length <= 15 || 'Значение должно быть больше 15 символов',
          ],
          "order": 1,
        },
        {
          "text": "дата выдачи свидетельства",
          "dataField": "gpdtb23K22",
          "typeVar": "date",
          "rules": 1,
          "order": 2,
        },
        {
          "text": "дата окончания действия",
          "dataField": "gpdte23K22",
          "typeVar": "date",
          "rules": 1,
          "order": 3,
        },
        {
          "text": "примечание",
          "dataField": "gptxt23K22",
          "typeVar": "string",
          "rules": 0,
          "order": 4,
        },
      ]
    }
  },
  created() {
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
    maxTableHeight() {
      return window.innerHeight - 225 + 'px'
    },
    headersForRows() {
      return this.headers.massive.filter(el => el.variable).map(el => {
        return {
          ...el,
          styles: (row) => {
            if (el.dataField !== 'npg')
              return row.uslName ? 'display: none;' : 'justify-content: unset; text-align: center; '
            else
              return ''
          },
          colsDataCalc: (row, cell) => {
            if (el.dataField !== 'npg')
              return cell.cols;
            else
              return row.uslName ? 7 : 1;
          },
          props: (row, cell, loading) => {
            return {
              value: row[cell.dataField],
              title: '',
              cell: cell,
              id: row.id,
              row: row,
              loading: loading,
            }
          }
        }
      })
    },
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    loadFullInfo() {
      this.full = !this.full;
      this.loadingDataTable()
    },
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm('part5', this.full, true, this.chosenChildOrg?.id)
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },
    clearDataForDialog() {
      this.mainHeaderTitle = '';
      this.dataForDialog = null;
      this.additionalData = null;
    },
    // eslint-disable-next-line no-unused-vars
    async openDialog(e, dataField, cell, row) {
      //заглушка на редактирование от 08.04.2022
      // return;
      if (row.spec)
        this.mainHeaderTitle = row.spec?.code + ' ' + row.spec?.name;
      else
        this.mainHeaderTitle = row.kcpUgs?.code + ' ' + row.kcpUgs?.name;
      this.additionalData = {
        id: row?.id ?? null,
        "spec": row?.spec?.id ? {
          "id": row?.spec?.id,
        } : null,
        "kcpUgs": row.kcpUgs?.id ? {
          "id": row.kcpUgs?.id,
        } : null,
        "sprOrgId": row.sprOrgId,
      };
      this.dataForDialog = {
        gpsnm23K22: row.gpsnm23K22,
        gptxt23K22: row.gptxt23K22,
        gpdte23K22: row.gpdte23K22,  //date
        gpdtb23K22: row.gpdtb23K22, //date
        gpsnp23K22: row.gpsnp23K22,
      };
      await this.$refs.dialog.openDialog()
    },
    formatDate(date) {
      if (!date) return null
      
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    async fetchDialogData(obj) {
      this.savingData = true;
      try {
        const res = await Form5Controller.saveForm5({
            ...obj,
            gptxt23K22: obj.gptxt23K22 ?? '',
            gpdte23K22: obj.gpdte23K22,
            gpdtb23K22: obj.gpdtb23K22,
          }, this.chosenChildOrg.id
        )
        if (res) {
          this.savingData = false;
          if (obj.id) {
            const index = this.serverData.findIndex(el => el.id === obj.id);
            this.serverData.splice(index, 1, res) //res.data
          } else if(obj?.spec) {
            const index = this.serverData.findIndex(el => el.spec?.id === obj.spec?.id);
            this.serverData.splice(index, 1, {...res, spec: this.serverData[index].spec})//res.data
          } else {
            const index = this.serverData.findIndex(el => el.kcpUgs?.id === obj.kcpUgs?.id);
            this.serverData.splice(index, 1, {...res, kcpUgs: this.serverData[index].kcpUgs})//res.data
          }
          this.dataForDialog = null;
          await this.$refs.dialog.closeDialog();
        }
        this.savingData = false;
      } catch (e) {
        this.savingData = false;
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Ошибка сохранения',
          timeout: 3000
        });
        console.log("e", e)
      }
    }
    
  },
}
</script>

<style scoped>

</style>